import { render, staticRenderFns } from "./YoutubeIconWhite.vue?vue&type=template&id=70d59141&scoped=true"
import script from "./YoutubeIconWhite.vue?vue&type=script&lang=ts"
export * from "./YoutubeIconWhite.vue?vue&type=script&lang=ts"
import style0 from "./YoutubeIconWhite.vue?vue&type=style&index=0&id=70d59141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d59141",
  null
  
)

export default component.exports